// Global UI styles migrated to goober for Preact components
import { glob } from 'goober';

// Move panel / control / legend styles here so CSS-in-JS (goober) manages
// all styles used by Preact components. The selectors are kept intact so
// existing DOM class names remain stable for tests and markup.
glob`
  /* Ensure Preact UI root uses the theme text color and common typographic base */
  #ui-root {
    color: var(--text);
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, 'Helvetica Neue', Arial, sans-serif;
    font-size: 13px;
    line-height: 1.3;
  }
  :root {
    /* Color system for Preact UI components */
    --bg: #ffffff;
    --panel-radius: 12px;
    --panel-shadow-sm: 0 2px 8px rgba(0,0,0,0.08);
    --panel-shadow-md: 0 4px 16px rgba(0,0,0,0.12);
    --panel-shadow-lg: 0 8px 32px rgba(0,0,0,0.16);
    --accent: #16a085;
    --accent-hover: #1abc9c;
    --accent-strong: #138871;
    --on-accent: #ffffff;
    --text-muted: #6b7280;
    --text: #1f2937;
    --text-light: #9ca3af;
    --muted-border: #e5e7eb;
    --light-bg: #f9fafb;
    --disabled-bg: #e5e7eb;
    --disabled-text: #9ca3af;
    --input-border: #d1d5db;
    --input-focus: var(--accent);
    --spinner-color: var(--accent);
    --hover-bg: rgba(22, 160, 133, 0.08);
  }

  [data-collapsed="true"] { 
    min-width: auto !important; 
    box-shadow: var(--panel-shadow-sm) !important;
  }
  [data-dragging="true"] { 
    opacity: 0.95;
    box-shadow: var(--panel-shadow-lg) !important;
    cursor: grabbing !important;
  }

  @keyframes spin { to { transform: rotate(360deg); } }

  /* Leaflet Popup Overrides to match Panel UI */
  .leaflet-popup-content-wrapper {
    padding: 0;
    border-radius: var(--panel-radius);
    box-shadow: var(--panel-shadow-md);
    overflow: hidden;
  }
  .leaflet-popup-content {
    margin: 0 !important;
    width: auto !important;
    line-height: 1.3;
  }
  .leaflet-container a.leaflet-popup-close-button {
    top: 8px;
    right: 8px;
    color: var(--text-muted) !important;
    font-size: 18px !important;
    padding: 4px;
    z-index: 10;
  }
  .leaflet-container a.leaflet-popup-close-button:hover {
    color: var(--accent) !important;
  }
`;
